import React, { useEffect, useState } from "react";
import Chart from ".//..//..//..//..//assets//images//icons//chart.svg";
import CheckBox from "../../../../components/common/checkbox/Checkbox";

const DropDown = ({ proposalFilterHandler, selectedProposalTypes }) => {
  const [toggle, setToggle] = useState(false);

  const handleToggleChange = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <div className="relative inline-block text-left">
        <div
          className="flex items-center gap-[20px] py-[0.7rem] px-[1.3rem] bg-secondary-color cursor-pointer rounded-[0.625rem]"
          onClick={handleToggleChange}
        >
          <img src={Chart} alt="flag" className="w-[1.125rem] " />
          <label className="text-white">Szűrők</label>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
            <path d="M4.375 7.58331L7.5 11.125L10.625 7.58331H4.375Z" fill="white" />
          </svg>
        </div>

        <div
          className={`${
            toggle === false ? "hidden" : ""
          } absolute right-0 z-10 mt-2  origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <div className="py-1" role="none">
            <div className="flex items-center gap-4 px-4 py-3 text-sm text-gray-700 cursor-pointer transition-all ease-in-out duration-100 hover:bg-[#e6eef0]">
              <CheckBox
                label={`Költöztetés`}
                name={"name"}
                id={`Költöztetés`}
                value={`Költöztetés`}
                onChange={(e) => proposalFilterHandler(e.target.value)}
              />
            </div>
            <div className="flex items-center gap-4 px-4 py-3 text-sm text-gray-700 cursor-pointer transition-all ease-in-out duration-100 hover:bg-[#e6eef0]">
              <CheckBox
                id={`Újbútor`}
                label={`Új bútor`}
                name={"name"}
                value={`Újbútor`}
                onChange={(e) => proposalFilterHandler(e.target.value)}
              />
            </div>
            <div className="flex items-center gap-4 px-4 py-3 text-sm text-gray-700 cursor-pointer transition-all ease-in-out duration-100 hover:bg-[#e6eef0]">
              <CheckBox
                id={`Lakásfelszámolás`}
                label={`Lakásfelszámolás`}
                name={"name"}
                value={`Lakásfelszámolás`}
                onChange={(e) => proposalFilterHandler(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DropDown;
